import React, { useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useHotels } from "../graphql/useHotels";
import ErrorMessage from "../components/ErrorMessage";
import Loading from "../components/Loading";
import Webview from "../components/Webview";
import { queryString } from "../utils/url";
import { setEnsureUserCallback, setSelectedHotel, getHotel } from "../actions/hotel";
import { GET } from "../utils/get";
import usePostMessage from "../hooks/usePostMessage";
import useZonesMessage from "../hooks/useZonesMessage";
import { getZonesUrl } from "../actions/config";
import { useStats, persistStats } from "contexts/stats";

const Zones = () => {
    const dispatch = useDispatch();
    const selectedHotel = useSelector(getHotel);
    const get = GET(useLocation());
    const stats = useStats();

    useEffect(() => {
        return () => {
            persistStats({ stats, eventName: "zones" });
        };
    }, []);

    if (get.h) {
        const hotelRef = atob(get.h);
        if (hotelRef && selectedHotel !== hotelRef) {
            dispatch(setSelectedHotel(hotelRef));
        }
    }
    const zoneRef = get.z ? atob(get.z) : undefined;
    const ensureUserCallback = useSelector((state) => state.session.ensureUserCallback);
    const {
        loading,
        error,
        hotels: hotel,
    } = useHotels({
        ref: selectedHotel,
        autoload: true,
    });

    const initialIframePath = ensureUserCallback || "/";

    const { incoming, setIncoming, handleIcomingMessage } = usePostMessage();

    const { parseMessage, iframePath, redirectTo } = useZonesMessage(initialIframePath, setIncoming);

    useEffect(() => {
        if (ensureUserCallback) {
            dispatch(setEnsureUserCallback(null));
        }

        parseMessage("zones", incoming);

        window.addEventListener("message", handleIcomingMessage);
        return () => {
            window.removeEventListener("message", handleIcomingMessage);
        };
    }, [handleIcomingMessage, parseMessage, incoming, ensureUserCallback]);

    if (!selectedHotel) {
        return <Redirect push to="/site/list" />;
    }

    if (redirectTo) {
        return <Redirect push to={redirectTo} />;
    }

    let url = getZonesUrl() + iframePath;
    const urlParams = {};
    if (hotel) {
        urlParams.projectRef = hotel.ref;
        if (hotel.timeZone) urlParams.timeZone = hotel.timeZone;
    }
    if (zoneRef) {
        urlParams.zoneRef = zoneRef;
        urlParams.page = "detail";
    }
    if (url) {
        url += (url.match(/\?/) ? "&" : "?") + queryString(urlParams);
    }

    console.log(url);

    return (
        <>
            {!hotel && error ? (
                <ErrorMessage type="server" error={error} />
            ) : loading ? (
                <Loading />
            ) : (
                <section className="basic">
                    <div className="max-w-lg mx-auto">
                        <Webview
                            title={hotel ? hotel.name : ""}
                            url={url}
                            addParams={["lang", "token", "logged", "appType", "mobileTheme", "theme", "zones"]}
                        />
                    </div>
                </section>
            )}
        </>
    );
};

export default Zones;
